// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"24":"e77d9ef0","152":"e2051c3b","642":"d3f58738"}[chunkId] + ".chunk.js");